import { opFor, isLevelId, isTestLevelId } from '../../data/ids';
import { t } from '../../i18n/es';
import { formatNumber, padDigits } from '../format';

export interface HudModel {
  lives: string;
  dollars: string;
  score: string;
  operation: string;
}

/** The readouts of GDD §13.3 from the state of the core; the HUD only reads it. */
export function hudModel(levelId: string, core: { lives: number; dollars: number; score: number }): HudModel {
  const name = isLevelId(levelId) ? t(`mission.${levelId}.name`).toUpperCase() : null;
  const op = isLevelId(levelId) || isTestLevelId(levelId) ? opFor(levelId) : levelId;
  return {
    lives: t('ui.hud.lives', { lives: core.lives }),
    dollars: t('ui.hud.dollars', { dollars: padDigits(core.dollars, 3) }),
    score: t('ui.hud.score', { score: formatNumber(core.score) }),
    operation: name ? `${op} · ${name}` : op,
  };
}
